import { Space, Typography } from 'antd';
import { FieldHelperProps, FieldMetaProps } from 'formik';
import { FileTextOutlined } from '@ant-design/icons';
import { H3, SecondaryText } from 'components/new-ui/base/typography/styles';
import { InputLabelRequired } from 'components/ui/composed/declarations/formInput/DeclarationInput.styles';
import { SectionContainer } from '../styles';
import CustomerSelect from 'components/new-ui/composed/selects/CustomerSelect';

type Props = {
    editingPartyId: string | undefined;
    thirdPartyId: string | undefined;
    required?: boolean;
    fieldMeta?: FieldMetaProps<any>;
    fieldHelper?: FieldHelperProps<any>;
    onChange: (id?: string) => void;
    onClear: () => void;
};

const ThirdPartyBilling = ({
    thirdPartyId,
    editingPartyId,
    required,
    fieldMeta,
    fieldHelper,
    onChange,
    onClear,
}: Props) => {
    return (
        <SectionContainer>
            <Space size={6}>
                <FileTextOutlined style={{ color: 'var(--brand-6)', fontSize: 20 }} />
                <H3>Third Party Billing</H3>
            </Space>
            <SecondaryText>Select a third party to receive billing if applicable</SecondaryText>

            <div style={{ marginTop: 16 }}>
                <Typography>
                    {required && <InputLabelRequired right>*</InputLabelRequired>}
                    Third Party
                </Typography>
                <CustomerSelect
                    style={{ flex: 1, maxWidth: '100%' }}
                    placeholder="Select Third Party"
                    customerId={thirdPartyId}
                    fieldMeta={fieldMeta}
                    fieldHelper={fieldHelper}
                    // We don't show the customer that we're editing in the third-party options
                    // as it would not make sense to add ourselves as third-party
                    excludeIds={editingPartyId ? [editingPartyId] : undefined}
                    onChange={onChange}
                    onClear={onClear}
                />
            </div>
        </SectionContainer>
    );
};

export default ThirdPartyBilling;
